import { ReactNode } from 'react'
import { Box } from '@mui/material'

/**
 * One label/control row in a form panel. Labels sit in a fixed column so a
 * panel's controls line up, in the design system's field-label style
 * (10.5px uppercase, ink-500). `htmlFor` ties the label to the control.
 */
export const FormRow = ({
  label,
  htmlFor,
  children,
}: {
  label: string
  htmlFor?: string
  children: ReactNode
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: '180px minmax(0, 1fr)',
      alignItems: 'center',
      gap: '16px',
    }}
  >
    <Box
      component="label"
      htmlFor={htmlFor}
      sx={{
        fontSize: 10.5,
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        color: 'var(--ink-500)',
      }}
    >
      {label}
    </Box>
    {children}
  </Box>
)
